<a [routerLink]="url" *ngIf="url" class="rounded-full w-full py-2 px-5 text-white flex items-center text-xl"
   [ngClass]="{'pointer-events-none bg-gray-400': disabled, 'bg-black': !disabled && !secondary, 'bg-gray-500': !disabled && secondary, 'justify-between': !!icon, 'justify-center': !icon}">
  {{text}}
  <fa-icon [icon]="icon" *ngIf="icon"></fa-icon>
</a>
<button *ngIf="!url" class="rounded-full w-full py-2 px-5 items-center flex text-xl" [type]="buttonType"
        [ngClass]="{'pointer-events-none bg-gray-500 text-gray-400': disabled, 'text-white': !disabled, 'justify-start': alignment === 'left' && !icon, 'bg-black': !disabled && !secondary, 'bg-gray-500': !disabled && secondary, 'justify-between': !!icon, 'justify-center': !icon && alignment === 'center'}"
        [disabled]="disabled">
  {{text}}
  <fa-icon [icon]="icon" *ngIf="icon"></fa-icon>
</button>
